import classNames from './DealLimitReachedMessage.module.scss';
import classes from 'classnames';
import { useTranslation } from 'react-i18next';
import { Transition } from 'react-transition-group';

import { authSelector } from '@/store/reducers/auth';
import { useAppSelector } from '@/store';

import SVG from 'react-inlinesvg';
import AppBackdrop from '@/components/AppBackdrop';
import AppModal from '@/components/AppModal';

import closeIcon from '@/assets/svg/closeFill.svg';
import errorIcon from '@/assets/svg/error.svg';

interface DealLimitReachedMessageProps {
  show: boolean;
  onClose: () => void;
}

const DealLimitReachedMessage = ({ show, onClose }: DealLimitReachedMessageProps) => {
  const { t } = useTranslation();
  const { userRole } = useAppSelector(authSelector);
  const isAdmin = userRole === 'admin';

  const titleKey = isAdmin ? 'dealLimitReachedMessageAdminTitle' : 'dealLimitReachedMessageTitle';
  const descriptionKey = isAdmin
    ? 'dealLimitReachedMessageAdminDescription'
    : 'dealLimitReachedMessageDescription';

  return (
    <Transition
      in={show}
      timeout={400}
      mountOnEnter
      unmountOnExit
      children={state => {
        return (
          <>
            <AppBackdrop
              className={classes(classNames.backdrop, `backdrop-${state}`)}
              emitClose={onClose}
            />
            <AppModal className={classNames.appModal}>
              <div className={classes(classNames.modal, `fade-${state}`)}>
                <button
                  className={classNames.closeBtn}
                  onClick={onClose}
                  aria-label={t('close').toString()}
                >
                  <SVG src={closeIcon} />
                </button>
                <SVG src={errorIcon} className={classNames.icon} />
                <h2>{t(titleKey)}</h2>
                <span
                  className={classNames.description}
                  dangerouslySetInnerHTML={{
                    __html: t(descriptionKey).toString(),
                  }}
                />
              </div>
            </AppModal>
          </>
        );
      }}
    />
  );
};

export default DealLimitReachedMessage;
